// WorkbenchPage — the authed, full-screen route for a repair session:
// /course/:courseId/workbench/:domain (the slot accepts a course code —
// Course.get_by_id resolves id, code, or default-course code). Reached
// from the tutor's start_repair pending-action button (slice 3); the
// docket itself is WorkbenchPanel.
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import WorkbenchPanel from './WorkbenchPanel';

export default function WorkbenchPage() {
  const { courseId, domain } = useParams();
  const navigate = useNavigate();
  return (
    <WorkbenchPanel
      courseId={courseId}
      domain={domain}
      onClose={() => navigate(`/course/${encodeURIComponent(courseId)}`)}
    />
  );
}
